<template>
  <el-form
    size="small"
    :inline="true"
    label-position="top"
  >
    <el-form-item
      label="Reference"
      style="width: 10%;"
    >
      <el-input :model="item.ref" />
    </el-form-item>
    <el-form-item
      label="Type"
      style="width: 10%;"
    >
      <el-select v-model="item.type">
        <el-option
          v-for="itemType in itemTypes"
          :key="itemType.id"
          :label="itemType.desc"
          :value="itemType.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      label="Description"
      maxlength="45"
      show-word-limit
    >
      <el-autocomplete
        v-model="item.desc"
        :fetch-suggestions="accountItemQuerySearch"
        :trigger-on-focus="false"
        placeholder="Item Description"
        class="w-100"
        :debounce="500"
        value-key="name"
        clearable
        @select="handleSelectItem"
      />
    </el-form-item>
    <el-form-item
      label="Quantity"
      style="width: 5%;"
    >
      <el-input v-model="item.quantity" />
    </el-form-item>
    <el-form-item
      label="Weight"
      style="width: 10%;"
    >
      <el-input
        v-model="item.weight"
      />
    </el-form-item>
    <el-form-item
      label="Length"
      style="width: 10%;"
    >
      <el-input v-model="item.len" />
    </el-form-item>
    <el-form-item
      label="Width"
      style="width: 10%;"
    >
      <el-input v-model="item.width" />
    </el-form-item>
    <el-form-item
      label="Height"
      style="width: 10%;"
    >
      <el-input v-model="item.height" />
    </el-form-item>
    <el-form-item
      label="Volume"
      style="width: 5%;"
    >
      <el-input
        v-model="item.vol"
        disabled
      />
    </el-form-item>
    <el-form-item
      label="Actions"
      style="float: right;"
    >
      <el-button
        type="primary"
        icon="el-icon-info"
        plain
        size="mini"
        style="margin-left: 5px;"
      />
      <el-popover
        placement="bottom"
        width="400"
        trigger="click"
      >
        <DG :account-id="accountId" />
        <el-button
          slot="reference"
          type="warning"
          plain
          size="mini"
          style="margin-left: 5px;"
          @click.native="isDgVisible = !isDgVisible"
        >
          DG
        </el-button>
      </el-popover>
      <el-button
        type="danger"
        icon="el-icon-delete"
        plain
        size="mini"
        style="margin-left: 5px;"
        @click.native="$emit('remove', index)"
      />
    </el-form-item>
  </el-form>
</template>
<script>
import DG from './Modals/DG'

export default {
  components: {
    DG
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: Object
    },
    itemTypes: {
      type: Array,
      required: false,
      default: Array
    },
    index: {
      type: Number,
      required: true
    },
    accountId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      accountItems: [],
      isDgVisible: false
    }
  },
  computed: {
    vol () {
      return (this.item.len * this.item.height * this.item.width) / 1000000
    }
  },
  watch: {
    'vol': function (newVal) {
      if (isNaN(newVal)) {
        this.item.vol = ''
      } else {
        this.item.vol = newVal
      }
    }
  },
  methods: {
    handleSelectItem () {

    },
    accountItemQuerySearch (queryString) {
      this.$sdk.account_item.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.filters = { 'name': queryString }
        builder.order = { 'name': 'asc' }
      }).then(res => {
        this.accountItems = res
      })
    }
  }
}
</script>
